import { ArrowUpward, AutoAwesome } from "@mui/icons-material";
import {
  Box,
  Card,
  Button,
  IconButton,
  LinearProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { postAiSummary } from "@/services/api";
import { useMutation } from "@tanstack/react-query";

export default function AISummary({ summary, title = "AI SUMMARY" }) {
  const [prompt, setPrompt] = useState("");
  const [response, setResponse] = useState("");
  const [lastPrompt, setLastPrompt] = useState("");
  const SUGGESTED_PROMPTS = [
    "Describe my core subscribers",
    "Where should I have my next meetup?",
  ];
  const mutation = useMutation({
    mutationFn: (prompt) => {
      setLastPrompt(prompt);
      setPrompt("");
      setResponse("");
      return postAiSummary(prompt);
    },
    onSuccess: (data) => {
      setResponse(data.response);
    },
  });

  const handleSubmit = async () => {
    mutation.mutate(prompt);
  };

  return (
    <Card
      sx={{
        borderRadius: 3,
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <AutoAwesome sx={{ fontSize: "1.3rem", color: "#04FFFF" }} />
        <Typography variant="caption" sx={{ fontWeight: 600, opacity: 0.7 }}>
          {title}
        </Typography>
      </Stack>

      {lastPrompt && (
        <Typography variant="body1" sx={{ color: "text.secondary" }}>
          {lastPrompt}
        </Typography>
      )}

      {mutation.isPending && (
        <LinearProgress color="secondary" sx={{ my: 4 }} />
      )}

      {response && (
        <Typography variant="body1" sx={{ color: "white" }}>
          {response}
        </Typography>
      )}

      <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
        <TextField
          label="Ask a question"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          fullWidth
          multiline
          disabled={mutation.isPending}
          sx={{
            "& .MuiInputBase-root": {
              borderRadius: "30px",
            },
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              console.log("enter");
              e.preventDefault();
              handleSubmit();
            }
          }}
        />
        <Box>
          <IconButton
            sx={{ backgroundColor: "#9A5AEF" }}
            size="large"
            onClick={handleSubmit}
            disabled={mutation.isPending}
          >
            <ArrowUpward />
          </IconButton>
        </Box>
      </Stack>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          mb: 2,
          width: "100%",
          overflowX: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        {SUGGESTED_PROMPTS.map((prompt) => (
          <Button
            key={prompt}
            variant="outlined"
            color="inherit"
            style={{
              opacity: 0.5,
              flexShrink: 0,
              whiteSpace: "nowrap",
              minWidth: "auto",
            }}
            onClick={() => setPrompt(prompt)}
          >
            {prompt}
          </Button>
        ))}
      </Stack>
    </Card>
  );
}
